


<template>
  <div>

    <LightGallery
      :images="images"
      :index="index"
      :disable-scroll="true"
      @close="index = null"
    />
    
    <div class="row">
        <div class="col-md-3 col-sm-6" @click="index = thumbIndex" v-for="(thumb,thumbIndex) in images" :key="thumbIndex">
            <div>
                <a >
                    <div  @click="index = thumbIndex" class="infografia-thumb">
                        <img :src="thumb.url" alt="infografia Item 5">
                        <div class="overlay">
                            <div class="inner">
                                <h4 style="color:#CA9C1D">{{thumb.Nombre}}</h4>
                            </div>
                        </div> 
                    </div> 
                </a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import { LightGallery } from 'vue-light-gallery';

  export default {
    props:['value'],
    components: {
      LightGallery,
    },
    data() {
      return {
        images:this.value,
        index: null,
      };
    },
  };
</script>